import React from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';

import Select from 'components/Select/desktop';
import Button from 'components/Button';
import InputDate from 'components/InputDate/desktop';
import Input from 'components/Input';

import DaysFilter from '../../../../DaysFilter';

import './FilterBlock.scss';

const b = block('filter-block');

const FilterBlock = ({
  isMobile,
  handleFormSubmit,
  handleKeyDown,
  handleStructureChange,
  onChangeFilterValue,
  onChangeBeginDate,
  onChangeEndDate,
  onChangeActiveDay,
  values,
}) => {
  const locale = useSelector(state => state.locale.locale);

  const { activeDay, structure, filters, filterValue, date } = values;

  return (
    <form className={b({ isMobile })} onSubmit={handleFormSubmit} onKeyDown={handleKeyDown} tabIndex={0}>
      <div className={b('header')}>{locale.filter}</div>

      <div className={b('wrapper')}>
        <div className={b('left')}>
          <DaysFilter activeDay={activeDay} setActiveDay={onChangeActiveDay} isMobile={isMobile} />

          <div className={b('inputs')}>
            <div className={b('input')}>
              <div className={b('title')}>{locale.show}</div>
              <Select
                name="structure"
                items={structure}
                activeItem={filters?.structure}
                onChange={handleStructureChange}
              />
            </div>

            <div className={b('input')}>
              <div className={b('title')}>{locale.agent}</div>
              <Input
                size="low"
                value={filterValue}
                callBack={onChangeFilterValue}
                placeholder={locale.login}
                name="agent"
              />
            </div>
          </div>
        </div>

        <div className={b('or')}>{locale.or}</div>

        <div className={b('right')}>
          <div className={b('date')}>
            <div className={b('date-row')}>
              <div className={b('title')}>{locale.dateFrom}</div>
              <div className={b('date-input')}>
                <InputDate selected={date.beginDate} onChange={onChangeBeginDate} />
              </div>
            </div>
            <div className={b('date-row')}>
              <div className={b('title')}>{locale.dateTo}</div>
              <div className={b('date-input')}>
                <InputDate selected={date.endDate} onChange={onChangeEndDate} />
              </div>
            </div>
          </div>

          <div className={b('button')}>
            <Button size="low" text={locale.acceptFilter} type="submit" />
          </div>
        </div>
      </div>
    </form>
  );
};

export default FilterBlock;
